import { Schema, Field, Float32, Float64, Uint8, FixedSizeList } from '@loaders.gl/tables';
export function makeSchemaFromAttributes(attributes) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var metadataMap = null;

  for (var key in metadata) {
    metadataMap = metadataMap || new Map();

    if (key !== 'value') {
      metadataMap.set(key, JSON.stringify(metadata[key]));
    }
  }

  var fields = [];

  for (var attributeName in attributes) {
    var attribute = attributes[attributeName];
    var field = getArrowFieldFromAttribute(attributeName, attribute);
    fields.push(field);
  }

  return new Schema(fields, metadataMap);
}

function getArrowFieldFromAttribute(attributeName, attribute) {
  var metadataMap = new Map();

  for (var key in attribute) {
    if (key !== 'value') {
      metadataMap.set(key, JSON.stringify(attribute[key]));
    }
  }

  var type = getArrowTypeFromTypedArray(attribute.value);
  var isSingleValue = !('size' in attribute) || attribute.size === 1;
  return isSingleValue ? new Field(attributeName, type, false, metadataMap) : new Field(attributeName, new FixedSizeList(attribute.size, new Field('value', type)), false, metadataMap);
}

function getArrowTypeFromTypedArray(array) {
  switch (array.constructor) {
    case Float32Array:
      return new Float32();

    case Float64Array:
      return new Float64();

    case Uint8Array:
      return new Uint8();

    default:
      throw new Error('array type not supported');
  }
}
//# sourceMappingURL=schema-attribute-utils.js.map